export function tabs() {
    const tabNav = $(".tab-nav");
    const tabLinks = tabNav.find("a");

    tabLinks.on("click", function (event) {
        let $this = $(this);
        let target = $this.attr("href");

        if (!$this.parent().hasClass("active")) {
            $(target).addClass("active").siblings().removeClass("active");
            $this.parent().addClass("active").siblings().removeClass("active");
            $(target).find("a, button")[0] && $(target).find("a, button")[0].focus();
        }

        $("html, body").animate({
            scrollTop: tabNav.offset().top
        }, 700);

        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js